import { useTranslation } from 'react-i18next'
import { APP_LINKS } from '../../data/siteContent'

const AppleIcon = () => (
  <svg viewBox="0 0 24 24" className="h-7 w-7 fill-current" aria-hidden>
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
  </svg>
)

const PlayIcon = () => (
  <svg viewBox="0 0 24 24" className="h-7 w-7" aria-hidden>
    <path fill="#34A853" d="M3.6 2.4 14.4 12 3.6 21.6V2.4z" />
    <path fill="#FBBC04" d="M14.4 12 20.4 7.2v9.6L14.4 12z" />
    <path fill="#4285F4" d="M20.4 7.2 14.4 12l6 4.8V7.2z" />
    <path fill="#EA4335" d="M3.6 2.4 14.4 12 20.4 7.2 3.6 2.4z" opacity=".001" />
  </svg>
)

function StoreBadge({ href, icon: Icon, label, sublabel, variant = 'dark' }) {
  const base =
    variant === 'dark'
      ? 'bg-black text-white hover:bg-primary'
      : 'bg-white text-primary border border-border hover:border-accent'

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex min-w-[200px] items-center gap-3 rounded-xl px-5 py-3.5 shadow-md transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg ${base}`}
    >
      <Icon />
      <span className="flex flex-col leading-tight">
        <span className="text-[10px] uppercase tracking-wide opacity-80">{sublabel}</span>
        <span className="text-sm font-semibold">{label}</span>
      </span>
    </a>
  )
}

export default function AppDownloadBadges({ className = '' }) {
  const { t } = useTranslation()

  return (
    <div className={`my-10 flex flex-wrap gap-4 ${className}`}>
      <StoreBadge
        href={APP_LINKS.ios}
        icon={AppleIcon}
        sublabel={t('appDownload.appStoreSublabel')}
        label={t('appDownload.appStoreLabel')}
      />
      <StoreBadge
        href={APP_LINKS.android}
        icon={PlayIcon}
        sublabel={t('appDownload.googlePlaySublabel')}
        label={t('appDownload.googlePlayLabel')}
      />
    </div>
  )
}
